// Label for whatever a dynamic player currently points at.
//
// A source is stored as a container plus the item picked inside it: `source` is
// the live stream, the VOD folder, or — for a live recording — the auto-created
// "pseudo-VOD" folder, which core names after the live stream it records
// (`name: streamObj.name`). `subSource` is the chosen file or DVR archive.
//
// Two consequences make `source.name` alone the wrong thing to render:
//  - a live stream and a recording *of that same live stream* produce an
//    identical label, so repointing between them looks like nothing saved
//  - the Meta schema holding `subSource` has no `name` column at all, so
//    `subSource.name` is always undefined; the label lives in `data.fileName`
//    for an upload and `data.name` for a DVR archive

// `source.liveParent` is populated on the single-player endpoint but not on the
// list one, so the container/item split below deliberately doesn't branch on it.
export function dynamicPlayerSourceLabel(player, fallback = '') {
  const source = player?.source;
  if (!source) return fallback;
  if (!player?.subSource) return source.name || fallback;

  const data = player.subSource.data;
  const item = data?.fileName || data?.name;
  if (!item) return source.name || fallback;

  // Same "folder / item" shape the source picker uses for sub-folders, so the
  // row reads back the way it was selected.
  return source.name ? `${source.name} / ${item}` : item;
}
